"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealingEffectHandler = exports.HealingEffectArgs = void 0;
const AttributeType_1 = require("../../enums/AttributeType");
const Healed_1 = require("../../events/core/Healed");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const core_1 = require("../../vfx/core");
class HealingEffectArgs {
    constructor(amount, crit, animate, attributePercent = 100) {
        this.amount = amount;
        this.crit = crit;
        this.animate = animate;
        this.attributePercent = attributePercent;
        this.__type = EffectType_1.EffectType.Healing;
        this.__typeName = "Healing";
        this.name = "Healing";
        this.harmful = false;
    }
}
exports.HealingEffectArgs = HealingEffectArgs;
let HealingEffectHandler = class HealingEffectHandler {
    apply(sequence, container, state) {
        const [percentDecrease, percentIncrease,] = container.getAttributeScores(state.creatorId, [
            AttributeType_1.AttributeType.PercentHealingDecrease,
            AttributeType_1.AttributeType.PercentHealingIncrease
        ]);
        const [percentReceivedDecrease] = container.getAttributeScores(state.targetId, [
            AttributeType_1.AttributeType.PercentHealingReceivedDecrease
        ]);
        let amount = Math.max(0, Math.round(state.args.amount * (1 - (percentDecrease + percentReceivedDecrease) / 100)));
        amount = Math.max(0, Math.round(amount * (1 + percentIncrease / 100)));
        const maxHealth = container.getMaxAttributeScore(state.targetId, AttributeType_1.AttributeType.Health);
        const healthBefore = container.getAttributeScore(state.targetId, AttributeType_1.AttributeType.Health);
        const healthAfter = healthBefore > maxHealth ? healthBefore
            : Math.min(maxHealth, healthBefore + amount);
        const appliedAmount = healthAfter - healthBefore;
        state.meta.amount = appliedAmount;
        sequence = sequence.pushSequence("parallel");
        container.setHealth(sequence, state.targetId, healthAfter);
        sequence
            .push(core_1.FloatingTextVfxStepArgs.fromHealing(state.targetId, appliedAmount, state.args.crit))
            .push(state.args.animate ? core_1.AnimateCharacterVfxStepArgs.Healed(state.targetId) : new core_1.NoneVfxStepArgs())
            .push(core_1.BattleLogEntryVfxStepArgs.fromHealing(container, state.creatorId, state.targetId, appliedAmount))
            .push(new core_1.CharacterSoundEffectVfxStepArgs(state.targetId, "healed"));
        container.emitEvent(sequence, state.targetId, new Healed_1.HealedEventArgs(state.creatorId, state.meta.amount));
    }
    remove(sequence, container, state) {
        // TODO: Do we support this?
    }
};
HealingEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Healing)
], HealingEffectHandler);
exports.HealingEffectHandler = HealingEffectHandler;
